module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAhFBMVEUAAADEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzXEEzX////FFzjLLkzppLLRRmH87/L66+344OTuu8XnoK3llqXefI/ZZXvNNFLJJkX+/P388/X55en22d/ssbzqq7fmnKrmmqnii5zhhpfddorbboPXXnXOPVnsFB2NAAAADnRSTlMA1yv5Bo6VlJD0vbuYCXy9wIgAAACvSURBVCjPfdLXFoIwEIThTTCKbQawi9i77/9+UjwSDgn/7Xe3O1KkjQrwL1BGS1VvgFaTaSljOBr1curD2UBEw5MW4yMjykdKArSK0gxAIA5ZcY08ccn+7aToTL5gUZzMfnIhn7Bpy0NlCblFg7IT54VdyQeahHjJ+Qcb8o6aalusyQ3ahN2R5A021bZgAiv7UHEaWTLsOq/xUdjxSu8A+l2z8Y+tSof2RIcqLCf6Be4VI79darmIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/icon-select.png
// module id = C72w
// module chunks = 21